module.exports = __webpack_public_path__ + "static/media/13.ce527654.jpg";